export default __webpack_public_path__ + "static/media/homeIcon.1fa6c48c.svg";